import Http from '../utils/http';
import LocalStorage from '../utils/localStorage';
import FiltrosDaTela from '../utils/filtrosDaTela';

const http = new Http(`${process.env.URL_API_SEGURANCA}`);
const metodos = {
  obterInformacoesDeAutenticacaoDoSeguranca: (identificadorDoUsuario) => {
    const httpApi = new Http(`${process.env.URL_BASE}`);

    const url = `/Usuario/ObterInformacoesDeAutenticacaoDoSeguranca/${identificadorDoUsuario}`;
    return httpApi.get(url);
  },
  login: (token) => {
    const body = 'grant_type=password&modulo=CONTROLE DE SALDO';
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: token,
    };
    return http.post('ProvedorDeIdentidade/token', body, headers);
  },
  obterPermissoes: (tokenDeAutorizacao) => {
    http.setarTokenDeAutenticacao(tokenDeAutorizacao);

    return http.get('/ProvedorDeIdentidade/Permissoes');
  },
  guardarSessao: (login, nomeDoUsuario, emailDoUsuario, tokenDoSeguranca, tokenDeAutorizacaoDoKeycloak) => {
    const dataDeExpiracao = new Date().setSeconds(86380);

    /* TODO: dívida técnica:
    https://dev.azure.com/solucoesdigix/Projetos/_workitems/edit/114416
    ao setar o token no metodo obterPermissoes, que é o token do Seguranca,
    ele passa a ser o default enviado no header de todos os requests (entender o porquê)
    por isso, é necessário setar o token do Keycloak novamente como o padrão
    */
    http.setarTokenDeAutenticacao(tokenDeAutorizacaoDoKeycloak);

    LocalStorage.atribuir('usuario', { login, nomeDoUsuario, emailDoUsuario, tokenDoSeguranca, tokenDeAutorizacaoDoKeycloak }, dataDeExpiracao);
  },
  guardarPermissoes: permissoes => LocalStorage.atribuir('permissoes', permissoes),
  possuiPermissao: (permissao) => {
    const permissoes = LocalStorage.obter('permissoes') || [];

    return permissoes.includes(permissao);
  },
  estaLogado: () => {
    const usuarioLogado = LocalStorage.obter('usuario') || {};

    return usuarioLogado.login !== undefined && usuarioLogado.tokenDoSeguranca !== undefined;
  },
  obterUsuarioLogado: () => LocalStorage.obter('usuario'),
  deslogar: () => {
    LocalStorage.remover('usuario', 'permissoes', 'protocolo');
    FiltrosDaTela.limparTodos();
  },
  alterarSenha: () => http.get('Usuario/ModuloAlterarSenha'),
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$usuario = metodos;
    Vue.prototype.$usuarioLogado = metodos.obterUsuarioLogado();
  },
};

export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/usuario.js